export default __webpack_public_path__ + "static/media/mobile.3a0abbcc.png";